import scrollAnimate from "./scroll-animate.js";
const directives = {
  "scroll-animate": scrollAnimate,
};

export default {
  install(Vue) {
    console.log("Directives installed");
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
